import React from 'react';
import { DataTable } from '../components/DataTable';
import { LoadingBlock } from '../components/LoadingBlock';
import { SectionCard } from '../components/SectionCard';

function ChampionshipSelect({ championships, selectedChampionshipId, onSelectChampionship }) {
  if (!championships.length) {
    return null;
  }

  return (
    <label>
      Campeonato
      <select value={selectedChampionshipId ? String(selectedChampionshipId) : ''} onChange={(event) => onSelectChampionship(event.target.value ? Number(event.target.value) : null)}>
        {championships.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
      </select>
    </label>
  );
}

export function RankingPage({ loading, error, data, championships = [], selectedChampionshipId, onSelectChampionship }) {
  if (loading) return <LoadingBlock label="Carregando ranking..." />;
  if (error) return <div className="page-error">{error}</div>;

  const rows = data?.rows || [];
  const leader = rows[0] || null;
  const bestAttack = rows.reduce((best, current) => (!best || Number(current.goals_for || 0) > Number(best.goals_for || 0) ? current : best), null);
  const bestDefense = rows.reduce((best, current) => (!best || Number(current.goals_against || 9999) < Number(best.goals_against || 9999) ? current : best), null);

  return (
    <SectionCard
      title="Ranking"
      subtitle="Classificação consolidada por campeonato."
      actions={<ChampionshipSelect championships={championships} selectedChampionshipId={selectedChampionshipId} onSelectChampionship={onSelectChampionship} />}
    >
      <div className="callout-box compact-box admin-callout">
        <span className="eyebrow">Leitura do administrador</span>
        <strong>Ranking oficial e auditável</strong>
        <p>O ranking é recalculado automaticamente a partir dos jogos encerrados. O admin usa esta tela para conferir liderança, saldo, pontos e consistência da competição, não para editar manualmente a tabela.</p>
      </div>

      <div className="callout-grid admin-summary-grid">
        <div className="callout-box compact-box"><span className="eyebrow">Líder</span><strong>{leader?.team_name || '-'}</strong><p>{leader ? `${leader.points} pts • saldo ${leader.goal_diff}` : 'Sem dados do campeonato.'}</p></div>
        <div className="callout-box compact-box"><span className="eyebrow">Melhor ataque</span><strong>{bestAttack?.team_name || '-'}</strong><p>{bestAttack ? `${bestAttack.goals_for} gols marcados` : 'Sem dados consolidados.'}</p></div>
        <div className="callout-box compact-box"><span className="eyebrow">Melhor defesa</span><strong>{bestDefense?.team_name || '-'}</strong><p>{bestDefense ? `${bestDefense.goals_against} gols sofridos` : 'Sem dados consolidados.'}</p></div>
        <div className="callout-box compact-box"><span className="eyebrow">Times na tabela</span><strong>{rows.length}</strong><p>Participantes do campeonato filtrado.</p></div>
      </div>

      <DataTable
        rows={rows}
        columns={[
          { key: 'rank_position', label: 'Pos.' },
          { key: 'team_name', label: 'Time' },
          { key: 'points', label: 'Pts' },
          { key: 'matches_played', label: 'J' },
          { key: 'wins', label: 'V' },
          { key: 'draws', label: 'E' },
          { key: 'losses', label: 'D' },
          { key: 'goal_diff', label: 'SG' },
        ]}
        emptyText="Sem ranking disponível para o campeonato selecionado."
      />
    </SectionCard>
  );
}
